import { useCallback } from 'react'

import refreshPage from '@/client/utils/refreshPage'

import AgeAssuranceGuide from '@/components/AgeAssurance/AgeAssuranceGuide'
import ModalV3 from '@/components/UI/Modal/ModalV3'

export default function AgeAssuranceModal({
  isOpen,
  onClose,
}: {
  isOpen: boolean
  onClose: () => void
}) {
  const onModalExit = useCallback(async () => {
    await refreshPage()
    onClose()
  }, [onClose])

  return (
    <ModalV3
      open={isOpen}
      onClose={onModalExit}
      size="2xl"
      title="Schoolhouse cares about your safety!"
      body={() => <AgeAssuranceGuide onExitButtonClick={onModalExit} showExitButton />}
    />
  )
}
